import { useQuery } from "react-query";
import { User } from "../../types/user";
import { getUserInfo } from "services/auth-service";
import authKeys from "queryKeyFactory/authKeys";
import { useAppDispatch } from "app/hooks";
import { setUserInfo } from "state/authSlice";

export default function useGetUserInfo() {
    const userId = localStorage.getItem("user_id") || "";
    const dispatch = useAppDispatch()
    return useQuery<any, Error, User>(authKeys.userInfoById(userId), () => getUserInfo(userId), {
        enabled: !!userId,
        select: (res) => res.data[0],
        onSuccess: (res) => {
            dispatch(setUserInfo(res))
        },
        refetchOnWindowFocus: false,
    })
}